<template>
    <span>
        <button
            v-if="disclosureTokens"
            v-once
            :id="disclosurBtnId"
            :data-target="disclosureId"
            :target="target"
            class="disclosure-link a11y-modal-trigger"
            @click="handleClick()">{{ disclosureText }}</button>
        <a11y-modal :id="disclosureId">
            <template #h4> {{ DisclosureHeadingText }} </template>
            <div
                slot="body"
                class="disclosures-section"
                v-html="ModalBody"></div>
        </a11y-modal>
    </span>
</template>
<script>
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from './a11y-modal.vue';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import makeHttpRequest from '~/helpers/ajax';

    export default {
        components: {
            A11yModal,
        },
        props: {
            disclosureText: {
                default: 'Advertising Disclosures',
            },
            disclosurePreText: {
                default: '',
            },
            disclosureTokens: {
                default: '',
            },
            openDisclosureModal: {
                default: false,
            },
            disclosureId: {
                type: String,
                default: 'disclosure',
            },
            disclosureHeadingText: {
                default: 'Advertising Disclosures',
            },
        },

        data() {
            return {
                ShowModal: false,
                ModalBody: '',
                target: '',
                DisclosureHeadingText: '',
            };
        },
        computed: {
            disclosurBtnId() {
                return `${this.disclosureId}_btn`;
            },
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
                this.DisclosureHeadingText = this.disclosureHeadingText;
            }, 1000);
        },
        methods: {
            handleClick() {
                let result = false;
                if (typeof this.disclosureTokens !== 'undefined' && this.openDisclosureModal.toString().toLowerCase() === 'true') {
                    this.fetchData();
                    this.ShowModal = true;
                    result = false;
                } else if (this.target === '') {
                    this.fetchData();
                    this.ShowModal = true;
                    result = false;
                } else if (window.location.hostname.indexOf('.lendingtree') < 0) {
                    this.fetchData();
                    this.ShowModal = true;
                    result = false;
                }
                return result;
            },
            fetchData() {
                this.ModalBody = '';
                if (typeof this.disclosureTokens !== 'undefined') {
                    // Removed 0 from Token starting
                    let tokens = this.disclosureTokens.split(',');
                    Object.keys(tokens).forEach((key) => {
                        if (tokens[key]) tokens[key] = parseInt(tokens[key], 10);
                    });
                    tokens.push('default');
                    tokens = tokens.join(',');

                    const url = `${wwwUrlEnv.getWWWURL()}/wp-json/wp/v2/disclosure?slug=${tokens}`;
                    const request = {
                        url,
                        storage_key: this.disclosureTokens,
                        expTime: 15 * 60 * 1000,
                        headers: { 'x-requested-with': 'XMLHttpRequest' },
                    };
                    return makeHttpRequest(request).then((response) => {
                        const disclosureData = JSON.parse(response);
                        tokens.split(',').forEach((disclosureNumber) => {
                            let disclosure = {};
                            Object.keys(disclosureData).forEach((key) => {
                                if (disclosureData[key].slug === disclosureNumber) disclosure = disclosureData[key];
                            });
                            if (disclosure && disclosure.content && disclosure.content.rendered && disclosure.acf && disclosure.acf.header !== 'Not Found') {
                                if (disclosureNumber !== 'default') {
                                    this.ModalBody += `<label class="disclosure-number">Disclosure ${disclosureNumber}</label>`;
                                }
                                this.ModalBody += `<label class="details-title">${disclosure.acf.header}</label>`;
                                this.ModalBody += `<div class="disclosure-post">${disclosure.content.rendered}</div><span class="divider"></span>`;
                            } else {
                                this.ModalBody = '<h3>Advertising Disclosures Not found.</h3>';
                            }
                        });
                    }, (error) => {
                        console.warn(`There is some issue with network call, please try again: ${error}`);
                    });
                }
                return false;
            },
        },
    };
</script>

<style lang="scss">
@import "../../../assets/styles/v2/variables";
.a11y-modal {
    .a11y-modal-dialog {
        max-width: 900px;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 auto;
        border-radius: 5px;

        .a11y-modal-header {
            h2 {
                color: $brand-dark-blue;
                font-size: $fs-27;
                font-weight: $fw-normal;
                display: inline-block;
            }
        }

        .disclosures-section {
            color: $dark-grey;

            .details-title {
                display: block;
                margin-bottom: 15px;

                p {
                    font-size: $fs-20;
                    font-weight: normal;
                    margin: 0 0 20px;
                }
            }

            .disclosure-number {
                color: $brand-dark-blue;
                font-size: $fs-30;
                font-weight: $fw-bold;
                margin-bottom: 15px;
                display: inline-block;
            }

            .divider {
                margin: 20px 0;
                display: block;
                border-bottom: 1px solid #ddd;

                &:last-child {
                    display: none;
                }
            }

            .disclosure-post {
                font-size: $fs-16;
                line-height: 1.8em;

                p {
                    @extend .disclosure-post;
                }
            }
            ul li {
                color: #454545;
                list-style: disc;
                line-height: 1.6em;
                padding-left: 32px;
                margin-top: 0;
            }
        }
    }
}
</style>
<style src="../../../assets/styles/a11yModal.scss" lang="scss"></style>
